// GENERATED — do not edit by hand. Run `pnpm routes:generate`.
//
// A route is public iff its source file lives under a `(public)`
// segment in `src/app/`. Adding a file there places its URL in
// `PUBLIC_ROUTES` automatically; moving it out removes the URL.
// URLs not matched here require a Clerk session — middleware
// rejects unauthenticated requests for everything else.

export const PUBLIC_ROUTES: readonly RegExp[] = [
  /^\/\.well-known\/oauth-authorization-server\/?$/,
  /^\/\.well-known\/oauth-protected-resource\/?$/,
  /^\/api\/auth\/create-user\/?$/,
  /^\/api\/auth\/desktop\/active-organization\/?$/,
  /^\/api\/auth\/desktop\/refresh\/?$/,
  /^\/api\/auth\/desktop\/signin\/?$/,
  /^\/api\/auth\/forgot-password\/send-code\/?$/,
  /^\/api\/auth\/forgot-password\/verify-and-reset\/?$/,
  /^\/api\/auth\/reset-session\/?$/,
  /^\/api\/auth\/signout\/?$/,
  /^\/api\/auth\/users\/anon\/claim\/?$/,
  /^\/api\/auth\/verification\/email\/send-code\/?$/,
  /^\/api\/auth\/verification\/email\/verify-code\/?$/,
  /^\/api\/coach\/chat\/?$/,
  /^\/api\/coach\/session\/?$/,
  /^\/api\/deals\/[^/]+\/packages\/[^/]+\/document-share\/?$/,
  /^\/api\/deals\/[^/]+\/packages\/[^/]+\/download\/?$/,
  /^\/api\/deals\/[^/]+\/packages\/[^/]+\/download\/certificate\/?$/,
  /^\/api\/deals\/[^/]+\/request-access\/?$/,
  /^\/api\/flows\/tokens\/[^/]+\/access\/?$/,
  /^\/api\/flows\/tokens\/[^/]+\/validate\/?$/,
  /^\/api\/geo\/?$/,
  /^\/api\/inngest\/?$/,
  /^\/api\/link-tokens\/[^/]+\/renew\/?$/,
  /^\/api\/signing\/verify\/[^/]+\/?$/,
  /^\/api\/submissions\/tokens\/[^/]+\/renew\/?$/,
  /^\/api\/submissions\/tokens\/create-signin-token\/?$/,
  /^\/api\/submissions\/tokens\/info\/?$/,
  /^\/api\/v1\/key\/?$/,
  /^\/api\/v1\/openapi\.json\/?$/,
  /^\/api\/v1\/orgs\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/deals\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/deals\/[^/]+\/packages\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/deals\/[^/]+\/packages\/[^/]+\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/deals\/[^/]+\/packages\/[^/]+\/participants\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/deals\/[^/]+\/packages\/[^/]+\/share-link\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/deals\/[^/]+\/packages\/[^/]+\/submissions\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/deals\/[^/]+\/tasks\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/document-uploads\/[^/]+\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/document-uploads\/[^/]+\/complete\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/submissions\/[^/]+\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/submissions\/[^/]+\/resend\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/submissions\/[^/]+\/signing-links\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/submissions\/[^/]+\/void\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/tasks\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/tasks\/[^/]+\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/tasks\/[^/]+\/approve\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/tasks\/[^/]+\/claim\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/tasks\/[^/]+\/reject\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/tasks\/[^/]+\/transition\/?$/,
  /^\/api\/v1\/orgs\/[^/]+\/tasks\/assignee-candidates\/?$/,
  /^\/api\/webhooks\/moov\/local\/?$/,
  /^\/api\/webhooks\/vercel\/?$/,
  /^\/auth\/callback\/clerk\/?$/,
  /^\/deals\/[^/]+\/packages\/[^/]+\/document-share\/?$/,
  /^\/deals\/[^/]+\/packages\/[^/]+\/download\/?$/,
  /^\/deals\/[^/]+\/request-access\/?$/,
  /^\/forgot-password\/?$/,
  /^\/join\/?$/,
  /^\/join\/[^/]+\/subscribe\/?$/,
  /^\/jwks\/?$/,
  /^\/legal\/esign-consent\/?$/,
  /^\/link-expired\/?$/,
  /^\/login\/?$/,
  /^\/login\/email-link\/?$/,
  /^\/mcp\/?$/,
  /^\/oauth\/register\/?$/,
  /^\/oauth\/token\/?$/,
  /^\/signup\/?$/,
  /^\/verify\/?$/,
  /^\/verify-email\/?$/,
  /^\/verify\/[^/]+\/?$/,
];
